<template>
    <div v-if="enableSmartLinks" :data-kontent-item-id="itemId">
        <slot></slot>
    </div>
    <template v-else>
        <slot></slot>
    </template>
</template>
<script setup lang="ts">
const props = defineProps<{ itemId: string }>()
const enableSmartLinks = useRuntimeConfig().public.enableSmartLinks
</script>